import React, { useContext } from 'react';
import { Spin } from 'antd';
import { ThemeContext } from '../contexts/Theme.context';

export default function Loader() {
  const { state: theme } = useContext(ThemeContext);
  return (
    <>
      <Spin></Spin>
      <style jsx global>{`
        .ant-spin-dot-item {
          background-color: ${theme.secondaryColor};
        }
      `}</style>
    </>
  );
}
